import axios from "axios";

export default function updateBusinessHours(payload) {
  return new Promise((resolve, reject) =>
    axios
      .put("/support/api/v1/admin/business-hours", payload)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
